import Splide from '@splidejs/splide';

export default function init(container: HTMLElement) {
    const splide = container.querySelector('.splide') as HTMLElement;

    function initSplide(slider: HTMLElement) {
        const sliderNode = new Splide(slider, {
            type: 'slide',
            arrows: false,
            pagination: true,
            rewind: true,
            gap: '21px',
            perPage: 1,
            destroy: true,
            fixedWidth: '291px',
            breakpoints: {
                960: {
                    destroy: false,
                },
            },
        });
        sliderNode.mount();
    }

    if (splide != null) {
        initSplide(splide);
    }
}
